<ng-container [formGroup]="parent">
  <ng-container formGroupName="header">
    <div class="row">
      <div class="col-3 col-min-12">
        <div class="form-group has-float-label mb-2">
          <label class="form-label">Template Name</label>
          <p-select
            pInputText
            formControlName="templateId"
            (onChange)="onTemplateSelection()"
            [options]="templates"
            optionLabel="name"
            optionValue="id"
            [filter]="true"
            [showClear]="true">
          </p-select>
        </div>
      </div>
      <div class="col-3 col-min-12">
        <div class="form-group has-float-label mb-2">
          <div class="form-group has-float-label mb-2">
            <label class="form-label">Proposal #</label>
            <input
              pInputText
              jniAutoCompleteBlocker
              type="text"
              class="form-control"
              formControlName="proposalNumber" />
          </div>
        </div>
      </div>
      <div class="col-4 col-min-12 d-flex gap-3">
        <div class="form-group-label align-items-center pt-2 d-flex gap-2">
          <p-checkbox
            id="firm1"
            formControlName="revised"
            [binary]="true"
            (onChange)="onRevisedSelection($event)" />
          <label class="d-block form-check-label mt-2">Revised</label>
        </div>
        <div class="d-flex align-items-center">
          <a class="has-link pt-2 mt-1" (click)="onEmailSelection()">Email</a>
        </div>
      </div>
    </div>
    <div>
      <ngx-extended-pdf-viewer
        [base64Src]="proposalJournalPdf"
        [textLayer]="true"
        [showHandToolButton]="true"
        [showPresentationModeButton]="true"
        height="75vh"
        [filenameForDownload]="'Proposal-' + quoteId"></ngx-extended-pdf-viewer>
    </div>
  </ng-container>
</ng-container>
